import React from 'react'
import Link from 'gatsby-link'

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { timeOfDay: '' };
  }

  componentWillMount() {
    const moment = require('moment');
    let timeOfDay = 'Afternoon';
    const hour = moment().get('hour');
    if (hour < 12)
      timeOfDay = 'Morning'
    if (hour > 17 || hour < 2)
      timeOfDay = 'Evening'
    this.setState({ timeOfDay })
  }

  render() {
    return (
      <div>
        <h1>Good {this.state.timeOfDay}</h1>
        <p>I like turtles and short walks on the beach</p>
        <p>This site is currently under construction</p>
        <Link to="/family/">Family</Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js